import React from 'react';
import ReactDOM from 'react-dom/client';
import LayStat from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><LayStat /></React.StrictMode>);
